import { composeReducers } from 'common/util/composeReducers';

import { 
    getStudyTypesByInstitution, 
    getStudyRolesByInstitution,
    getTeamMembersByInstitution,
    loadingStudyState,
    studyStateLoaded,
    savingStudyState,
    studyStateSaved,
    setPotentialResearchersToStudyTeam,
    clearStudy,
    getStudyMetadata,
    getStudyStages,
    getUsableStudyTypesByInstitution
} from './createStudy';

import { 
    initializeStudyWorkflow,
    setField
} from './workflow';

import {
    loadStudy
} from './editStudy';


export default composeReducers(
    getStudyTypesByInstitution,
    getUsableStudyTypesByInstitution,
    getStudyRolesByInstitution,
    getTeamMembersByInstitution,
    loadingStudyState,
    studyStateLoaded,
    savingStudyState,
    studyStateSaved,
    setPotentialResearchersToStudyTeam,
    clearStudy,
    loadStudy,
    initializeStudyWorkflow,
    setField,
    getStudyMetadata,
    getStudyStages
);
